import type { Role } from '@gdladder/shared/entities';

export function permissionsFromRoles(roles: Role[]) {
    return roles.reduce((acc, role) => acc | role.PermissionBitField, 0);
}
